import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthenticationService } from '@core/services/authentication/authentication.service';
import { Observable } from 'rxjs';

export const otpGuard: CanActivateFn = (route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree  => {

    
    const authService= inject(AuthenticationService);
    const router= inject(Router)
  if (authService.getCredentialVerified()) {
      return true;
    } else {
      return router.createUrlTree(['auth/login']);
    }

 
};
